import { Component, Prop } from 'vue-property-decorator';
import { MenuEntry } from '@cms/interfaces/menu-entry';
import BpcPublicMenuEntry from '@cms/components/public-menu-entry/public-menu-entry.vue';
import Vue from 'vue';

@Component({
  name: 'bpc-public-menu-entry',
  components: {
    'bpc-public-menu-entry': BpcPublicMenuEntry,
  },
})
export default class PublicMenuEntry extends Vue {
  @Prop(Object) readonly menuEntry;

  get lang(): string {
    return this.$store.getters['auth/userLang'];
  }

  get useNewCMS(): boolean {
    return this.$store.getters['centerSettings/centerSettings']?.use_new_cms;
  }

  get tenantAlias(): string {
    return this.$clientRouter.getTenantAlias();
  }

  public menuEntryProfileRoute(profile_name: string) {
    this.$router.replace({ name: profile_name });
  }

  get isLoggedIn(): boolean {
    return this.$authService.isLoggedIn();
  }

  get canAccess(): boolean {
    return (
      this.menuEntry.access == 'all' ||
      (this.menuEntry.access == 'private' && this.isLoggedIn) ||
      (this.menuEntry.access == 'public' && !this.isLoggedIn)
    );
  }

  get menuEntryNewCmsUrl(): string {
    const protocol = window.location.protocol;
    const domain = this.$clientRouter.getTenantDomain(this.tenantAlias);
    return `${protocol}//${domain}/web/${this.lang}/page/${this.menuEntry.post?.alias}`;
  }

  get isDropdownToggle(): string {
    return this.withSubmenu ? 'dropdown-toggle' : '';
  }

  get withSubmenu(): boolean {
    return this.menuEntry.submenu.length > 0;
  }

  get submenu() {
    return this.withSubmenu ? this.menuEntry.submenu : [];
  }
}
